import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardPageComponent } from 'src/app/pages/dashboard/dashboard-page/dashboard-page.component';
import { SharedDatagridComponent } from './shared-datagrid.component';

const routes: Routes = [
    {
        path: '',
        component: SharedDatagridComponent
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedDatagridRoutingModule { }
